<section class="steps-header-container container">
    <header class="steps">
        <div class="circle" [ngClass]="{ 'active-circle': isStep1Active, 'inactive-circle': !isStep1Active }"></div>
        <div class="step" [ngClass]="{ 'active': isStep1Active, 'inactive': !isStep1Active }">{{ step1 }}</div>
    </header>
    <div class="segment"></div>
    <main class="steps">
        <div class="circle" [ngClass]="{ 'active-circle': isStep2Active, 'inactive-circle': !isStep2Active }"></div>
        <div class="step" [ngClass]="{ 'active': isStep2Active, 'inactive': !isStep2Active }">{{ step2 }}</div>
    </main>
    <div class="segment"></div>
    <footer class="steps">
        <div class="circle" [ngClass]="{ 'active-circle': isStep3Active, 'inactive-circle': !isStep3Active }"></div>
        <div class="step" [ngClass]="{ 'active': isStep3Active, 'inactive': !isStep3Active }">{{ step3 }}</div>
    </footer>
</section>